import qs from 'qs'

class Api {
  constructor({ url }) {
    this.apiUrl = url
  }

  async login(credential) {
    return this.call(`authentication`, credential, 'POST')
  }

  async get(endpoint, query = {}) {
    return this.call(endpoint, query, 'GET')
  }

  async create(endpoint, data) {
    return this.call(endpoint, data, 'POST')
  }

  async patch(endpoint, data) {
    return this.call(endpoint, data, 'PATCH')
  }

  async delete(endpoint, data) {
    return this.call(endpoint, data, 'DELETE')
  }

  async upload(data) {
    return this.call('assets', data, 'POST')
  }

  async uploadS3Asset(data, folder = '') {
    const endpoint = folder ? `s3-assets?folder=${encodeURIComponent(folder)}` : 's3-assets'
    return this.call(endpoint, data, 'POST')
  }

  async createS3Folder(folderName) {
    return this.call('s3-assets/folder', { folderName }, 'POST')
  }

  // CV Jobs API
  async getCvStorageStatus() {
    return this.call('cv-jobs/storage-status', {}, 'GET')
  }

  async getCvQueueStatus() {
    return this.call('cv-jobs/queue-status', {}, 'GET')
  }

  async regenerateMemberCv(memberId) {
    return this.call(`cv-jobs/regenerate/${memberId}`, {}, 'POST')
  }

  async getBulkCvPreview(days) {
    return this.call('cv-jobs/bulk/preview', { days }, 'GET')
  }

  async startBulkCvRegenerate(days) {
    return this.call('cv-jobs/bulk/regenerate', { days }, 'POST')
  }

  async getCvJobStatus(jobId) {
    return this.call(`cv-jobs/status/${jobId}`, {}, 'GET')
  }

  // SSE for CV job progress
  subscribeToCvJobProgress(jobId, onProgress, onError, onComplete) {
    const accessToken = localStorage.getItem('accessToken')
    const url = `${this.apiUrl}/cv-jobs/progress/${jobId}?access_token=${accessToken}`
    const eventSource = new EventSource(url)
    
    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data)
        onProgress(data)
        if (data.status === 'completed' || data.status === 'failed') {
          eventSource.close()
          if (onComplete) onComplete(data)
        }
      } catch (e) {
        console.error('Failed to parse SSE data:', e)
      }
    }
    
    eventSource.onerror = (error) => {
      console.error('SSE error:', error)
      eventSource.close()
      if (onError) onError(error)
    }
    
    return () => eventSource.close()
  }

  async call(endpoint, data, method) {
    const param = {
      method,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }
    const accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      param.headers.Authorization = `Bearer ${accessToken}`
    }
    if (method !== 'GET') {
      // Check if this is a file upload endpoint (POST only, and data must be a File)
      const isFileUpload = method === 'POST' && data && data.name && (
        endpoint === 'assets' || 
        (endpoint.startsWith('s3-assets') && !endpoint.includes('/folder'))
      )
      
      if (isFileUpload) {
        const formData = new FormData()
        formData.append('files', data, data.name)
        delete param.headers['Content-Type']
        param.body = formData
      } else if (data !== undefined) {
        param.body = JSON.stringify(data)
      }
    }
    const url = method === 'GET' ? `${endpoint}?${qs.stringify(data)}` : endpoint
    console.log('qs.stringify(data)', qs.stringify(data))
    console.log('API', method, url)
    console.log('param', param)
    try {
      const res = await fetch(`${this.apiUrl}/${url}`, param)
      const json = await res.json()
      if (res.status === 200 || res.status === 201) {
        return Promise.resolve(json)
      }
      if (res.status === 401) {
        return Promise.reject(Error('This is unauthorised.'))
      }
      return Promise.reject(Error(json.message))
    } catch (error) {
      return Promise.reject(Error('Please try again later.'))
    }
  }
}

export default new Api({ url: process.env.API_URL })
